import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Main from "./Main";
import { useGetRateAdjustmentCaseMerchantInfoQuery } from "../../features/api";

//加盟店情報取得
export const Update = () => {
  const { rateAdjustmentCaseNo, merchantBranchNo } = useParams();

  const { data: merchantInfo, refetch } =
    useGetRateAdjustmentCaseMerchantInfoQuery({
      rateAdjustmentCaseNo: rateAdjustmentCaseNo as string,
      merchantBranchNo: merchantBranchNo as string,
      merchantName: "",
      contractServiceCode: "",
    });

  useEffect(() => {
    refetch();
  }, [refetch]);

  return <Main merchantInfo={merchantInfo} />;
};
